import { IconEye, IconFile, IconMaximize, IconTrash } from '@tabler/icons-react';
import { useForm } from 'react-hook-form';
import axiosInstance from '../../utils/AxiosInstance';
import clsx from 'clsx';
import { useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';
import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { BButton } from '../ui/generic';
import BDrawer from '../BDrawer';
import ResizableIframe from '../ResizableIframe';

const Document = ({ file }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const fileUrl = `${import.meta.env.VITE_API_BASE_URL}/${file.link}`;

  const handlePreview = () => {
    setShowPreview((prev) => !prev);
  };
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useForm();
  const handleOpenModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };
  const deleteDocument = async () => {
    setError(null);
    const res = await axiosInstance.post('/internal_api/documents/remove', { id: file.id });
    if (res.data.error) {
      toast.error(res.data.message);
      setError(res.data.message);
    } else {
      setIsOpen(false);
      queryClient.invalidateQueries(['documents']);
    }
  };
  return (
    <div className={'rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm'}>
      <Dialog open={showPreview} onClose={() => setShowPreview(false)} className="relative z-50">
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="relative h-auto w-dvh space-y-4 rounded-lg border border-slate-200 bg-white px-2 py-4 shadow">
            <ResizableIframe src={fileUrl} id={file.id} />
          </DialogPanel>
        </div>
      </Dialog>
      <Dialog open={isOpen} onClose={() => setIsOpen(false)} className="relative z-50">
        <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
          <DialogPanel className="max-w-lg space-y-4 rounded-lg border border-slate-200 bg-white px-2 py-4 shadow">
            <DialogTitle className="font-bold">Suppression du document</DialogTitle>
            <p>
              Êtes-vous sûr de vouloir supprimer ce document ? Cette action est définitive et ne peut pas être annulée.
            </p>
            <form onSubmit={handleSubmit(deleteDocument)} className="flex gap-4">
              <BButton
                isDisabled={isSubmitting}
                size={'sm'}
                color={'alternative'}
                label={'Annuler'}
                onClick={() => setIsOpen(false)}
              />
              <BButton
                isDisabled={isSubmitting}
                isProcessing={isSubmitting}
                size={'sm'}
                color={'red'}
                label={'Oui, supprimer'}
                type={'submit'}
              />
            </form>
          </DialogPanel>
        </div>
      </Dialog>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* File icon */}
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-slate-100 text-slate-700">
            <IconFile className={'size-5'} />
          </div>

          {/* File info */}
          <div className="flex flex-col">
            <span className="max-w-[200px] truncate text-sm font-medium text-slate-700">{file.name}</span>
            <span className="text-xs text-slate-400">{file.type_document}</span>
          </div>
        </div>

        {/* Actions */}
        <div className={'flex gap-1'}>
          <button onClick={handlePreview} className="text-slate-400 transition-colors hover:text-slate-600">
            <IconEye className={'size-5'} />
          </button>

          <div>
            <button
              onClick={handleOpenModal}
              type={'button'}
              className={clsx(
                'text-red-400 transition-colors hover:text-red-600',
                isSubmitting && 'pointer-events-none cursor-not-allowed opacity-80'
              )}
            >
              <IconTrash className={'size-5'} />
            </button>
          </div>
        </div>
      </div>
      <p className={'text-end text-xs text-red-400'}>{error}</p>
    </div>
  );
};

export default Document;
